





































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import TheTableRestaurantOrders from '@/components/orders/TheTableRestaurantOrders.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing function
import {getRestaurantOrders} from '@/ts/orders/get-orders';
// Importing Pusher
import Pusher from 'pusher-js';

export default {
    name: 'PageOrders',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableRestaurantOrders,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: Array(),
            search_param: String(),
            status: Object(),
            channel: Object(),
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            this.$store.dispatch('setLoadingOn');
            getRestaurantOrders(this.$route.params.id).then(() => {
                for (const item of this.$store.getters.response) {
                    this.$set(this.status, item.id, item.attributes.status);
                }
            }).finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        newOrder(data) {
            getRestaurantOrders(this.$route.params.id).then(() => {
                for (const item of this.$store.getters.response) {
                    this.$set(this.status, item.id, item.attributes.status);
                }
            });
            this.$notification.show('Имате нова поръчка', {
                body: data.message,
                icon: require('@/assets/img/ninja2.png'),
            }, {
                onclick() {
                    this.$router.push({ name: 'manage-orders', params: { id: this.$route.params.id }});
                },
            });
        },
    },
    beforeDestroy() {
        this.channel.unbind();
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: '/restaurants',
        }, {
            text: 'Поръчки',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        // Fetching data from the API
        this.$store.dispatch('setLoadingOn');
        getRestaurantOrders(this.$route.params.id).then(() => {
            for (const item of this.$store.getters.response) {
                this.$set(this.status, item.id, item.attributes.status);
            }
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });

        const pusher = new Pusher('1627464172e6c947c3f4', {
            cluster: 'eu',
            encrypted: true,
            authEndpoint: 'https://api.foodninja.net/broadcasting/auth',
            auth: {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + localStorage.getItem('jwt'),
                },
            },
        });

        // Subscribe to the channel we specified in our Laravel Event
        this.channel = pusher.subscribe('private-orders.' + this.$route.params.id);
        this.channel.bind('App\\Events\\OrderPlaced', this.newOrder);
    },
};
